export default __webpack_public_path__ + "static/media/flag.cda010a7.svg";